export const UPDATE_ITEM_INDEX = 'UPDATE_ITEM_INDEX';
export const UPDATE_MODAL_STATUS = 'UPDATE_MODAL_STATUS';
export const CLICK_INTRO_START_BUTTON = 'CLICK_INTRO_START_BUTTON';
export const CLICK_BUTTON = 'CLICK_BUTTON';

export function updateItemIndex(data) {
    return { type: UPDATE_ITEM_INDEX, data };
}

export function updateModalStatus(data) {
    return { type: UPDATE_MODAL_STATUS, data };
}


export function clickIntroStartButton(data) {
    return { type: CLICK_INTRO_START_BUTTON, data };
}

export function clickButton(data) {
    return { type: CLICK_BUTTON, data };
}



// WEBPACK FOOTER //
// ./actions/Modal/index.js